import { ConnectHttpTransport } from '@workflow-solutions/ofs-vuex-crud';

const providerInstance = new ConnectHttpTransport({ apiBase: window.$config.apiBase });

export default providerInstance;
